import API from '../api-service';

const baseUri = 'content';
const isLocal = process.env.NODE_ENV === 'local';

export default {
  getVideoSource(syncguid, parentSyncguid) {
    return API.get(`${baseUri}/${syncguid}/videoCookies`, {
      parentSyncguid,
    }).then(resp => {
      if (isLocal) {
        resp = resp.replace('play.dev.bizlibrary.com', 'playlocal.dev.bizlibrary.com:3000');
      }
      return {
        src: resp,
        type: 'application/x-mpegURL',
      };
    });
  },
};
